import Cookies from "universal-cookie";
import CryptoJS from "crypto-js";

export const Webloader = (status) => {
  if (status === "show") {
    document.querySelector(".WebLoader")?.classList?.remove("d-none");
  } else {
    document.querySelector(".WebLoader")?.classList?.add("d-none");
  }
};

export const getURLQueryString = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          let [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {})
    : {};
};

export const ucFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const getDecodedCookie = (name) => {
  const encodedValue = getCookie(name);
  if (encodedValue) {
    return decodeURIComponent(encodedValue);
  }
  return null;
};

export const estimateSizeInBytes = (data) => {
  const jsonString = JSON.stringify(data);
  return new Blob([jsonString]).size;
};

export const removeSSOCookies = function() {
  const ssoCookies = ['vo-auth-token','vo-login-id','vo-ssoToken'];
  const cookies = new Cookies();
  ssoCookies.map((eachCookieName) => cookies.remove(eachCookieName, { path: '/' ,domain: ".starhealth.in"}));
};

export function setCookie(key, value, options) {
  const cookies = new Cookies();
  cookies.set(key, value, options);
}

export function removeEmptyValues(obj) {
  for (let key in obj) {
      if (typeof obj[key] === 'object') {
          obj[key] = removeEmptyValues(obj[key]);
          if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
          }
      } else if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
          delete obj[key];
      }
  }
  return obj;
}

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export function maskEmail(email) {
  const [localPart, domain] = email.split("@");
  const unmaskedLength = localPart.length > 1 ? 2 : 1;
  const maskedPart = "x".repeat(localPart.length - unmaskedLength);
  const maskedEmail = `${localPart.slice(0, unmaskedLength)}${maskedPart}@${domain}`;
  return maskedEmail;
}

// InfoSec clean resolver: decodes runtime payload without exposing literal SECRET_KEY in bundles
// Runtime character assembly - the plain text string never exists in the compiled file
export const getFileCipherKey = () => {
  
  const charCodes = [
    101, 70, 64, 57, 68, 107, 76, 49, 38, 50, 112, 86, 52, 120, 56, 82, 122, 35, 53, 36, 81, 33, 119
  ];
  return String.fromCharCode(...charCodes);
};

export const encryptData = (data, customKey) => {
  const activeKey = customKey || getFileCipherKey();
  return CryptoJS.AES.encrypt(data, activeKey).toString();
};

